import React, { useEffect, useState } from "react";
import { Box, Typography, TextField } from "@mui/material";
import ImageUploader from "../imguploader/ImageUploader";
import CustomBtn from "../customButton/CustomBtn";
import "./UserProfile.css";
import { useDispatch, useSelector } from "react-redux";
import { updateProfileDataApi } from "../../api";
import { toast } from "react-toastify";
import { updateUser } from "../../redux/userSlice";

const EditProfile = ({ onClose }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.user?.user?.token);
  const users = useSelector((state) => state?.user?.user);
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    picture: "",
    phoneNo: "",
  });

  // console.log("susrr", users);

  const setData = () => {
    setUser({
      firstName: users.firstName || "",
      lastName: users.lastName || "",
      email: users?.email || "",
      picture: users?.picture || "",
      phoneNo: users?.phone || "",
    });
  };

  useEffect(() => {
    setData();
  }, []);

  const handleUpdateProfile = async () => {
    const confirm = window.confirm(
      "Are you sure you want to update your details ?"
    );
    if (!confirm) {
      return;
    }
    try {
      const response = await updateProfileDataApi({ token, user });
      console.log("response upload",response);
      
      dispatch(updateUser(response?.data));
      toast.success(response?.message);
      onClose();
    } catch (error) {
      if (error?.status === 500) {
        toast.error("Some error occured");
      } else {
        toast.error(error?.error);
      }
      console.log("error", error);
    }
  };

  const styles = {
    maxWidth: "337px",
  };
  return (
    <div className="edit-profile">
      <ImageUploader
        data="Upload Profile Image"
        picture={user.picture}
        setPicture={(newProfile) => setUser({ ...user, picture: newProfile })}
      />

      {/* Name Field */}
      <Typography className="edit-profile-label">First Name</Typography>
      <TextField
        value={user.firstName}
        onChange={(e) => {
          if (e.target.value.trim() !== "" || e.target.value === "") {
            setUser({ ...user, firstName: e.target.value });
          }
        }}
        className="edit-profile-input"
        type="text"
        name="name"
        placeholder="Type your Name"
       inputProps={{
        borderRadius:'28px'
       }}
      />

      <Typography className="edit-profile-label">Last Name</Typography>
      <TextField
        value={user.lastName}
        onChange={(e) => {
          if (e.target.value.trim() !== "" || e.target.value === "") {
            setUser({ ...user, lastName: e.target.value });
          }
        }}
        className="edit-profile-input"
        type="text"
        name="name"
        placeholder="Type your Name"
      />

      {/* Email Field */}
      <Typography className="edit-profile-label" style={{ marginTop: "15px" }}>
        Email
      </Typography>
      <TextField
        disabled
        value={user.email}
        onChange={(e) => setUser({ ...user, email: e.target.value })}
        className="edit-profile-input"
        type="email"
        name="email"
        placeholder="Type your Email"
      />

      {/* Mobile Number Field */}
      <Typography className="edit-profile-label" style={{ marginTop: "15px" }}>
        Mobile No
      </Typography>
      <TextField
        value={user.phoneNo}
        onChange={(e) => {
          const value = e.target.value;
          // Allow only numeric values with a maximum of 10 digits
          if (/^\d{0,10}$/.test(value)) {
            setUser({ ...user, phoneNo: value });
          }
        }}
        className="edit-profile-input"
        type="text"
        name="mono"
        placeholder="Type your Number"
      />

      <Box className="save-button-container">
        <CustomBtn text="Save" onClick={handleUpdateProfile} style={styles} />
      </Box>
    </div>
  );
};

export default EditProfile;
